import { Ziggy } from '@/data/ziggy';
import { route as routeFn, Router, ValidRouteName } from 'ziggy-js';

export type LocalizedZiggy = {
  (): Router;
  (name: ValidRouteName, params?: { [key: string]: unknown } | string | number | undefined, absolute?: boolean): string;
};

export default function createLocalizedZiggy(location: string, locale: string): LocalizedZiggy {
  return ((name: ValidRouteName, params = {}, absolute = isSubdomain) => {
    const localizedName = `${locale}.${name}`;

    if (Object.keys(Ziggy.routes).includes(localizedName)) {
      name = localizedName;
    }

    const url = new URL(location);

    // Necessary because the routes are generated with .test due to web.php: Route::domain(config('app.domain'))
    const correctZiggyDomain = JSON.parse(JSON.stringify(Ziggy).replace(/boostbuddy\.test/g, 'boostbuddy.' + url.hostname.split('.').pop()));

    // @ts-expect-error because we allow just a string as a param
    return routeFn(name, params, absolute, { ...correctZiggyDomain, location: url });
  }) as LocalizedZiggy;
}
